import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelRadio as _vModelRadio, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, vModelCheckbox as _vModelCheckbox, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "linking-business" }
const _hoisted_2 = { class: "linking-business__title" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "linking-business__sub-title sub-title" }
const _hoisted_5 = { class: "sub-title__prefix" }
const _hoisted_6 = { class: "sub-title__suffix" }
const _hoisted_7 = { class: "linking-business__radio-button-container radio-button-container" }
const _hoisted_8 = { class: "radio-button-container__default-input" }
const _hoisted_9 = {
  class: "radio-button-container__label",
  for: "radio-button-container__button--default-input"
}
const _hoisted_10 = { class: "radio-button-container__original-input" }
const _hoisted_11 = {
  class: "radio-button-container__label",
  for: "radio-button-container__button--original-input"
}
const _hoisted_12 = { class: "linking-business__linking-container linking-container" }
const _hoisted_13 = { class: "linking-container__at--content" }
const _hoisted_14 = { class: "linking-container__at--label label-container" }
const _hoisted_15 = { class: "label-container__title" }
const _hoisted_16 = ["onUpdate:modelValue"]
const _hoisted_17 = { class: "label-container__unused-label" }
const _hoisted_18 = {
  key: 1,
  class: "linking-container__at--unused"
}
const _hoisted_19 = { class: "linking-container__at--error" }
const _hoisted_20 = { class: "linking-business__button-container" }

import { i18n } from '@/i18n';
import TextButton from '@/components/input/Btn/TextButton.vue';
import { RegisterSettingStore } from '../../RegisterSettingStore';
import { storeToRefs } from 'pinia';
import SelectableField from '../SelectableField.vue';
import { LinkingBusinessHeader } from '../../interfaces/LinkingBusiness';
import { computed, ref, watch } from 'vue';
import { UNSELECTED_HEADER_VALUE } from '@/registerInputModule/constants';

export default /*@__PURE__*/_defineComponent({
  __name: 'LinkingBusiness',
  props: {
    store: {}
  },
  emits: ["on-click-next", "on-click-back", "on-click-use-previous-value"],
  setup(__props: any, { emit: __emit }) {

const t = i18n.t;

const props = __props;

const { state } = storeToRefs(props.store);
const selectedFieldId = ref<string>('');
const emits = __emit;

const imagesRequire = require.context('@/assets/img', false, /^\.\/register-input-step-flow-2.*\.png$/);
const localedRegisterInputStepFlowImage = ref(imagesRequire('./register-input-step-flow-2.png'));

watch(
  () => i18n.locale,
  (newVal) => {
    localedRegisterInputStepFlowImage.value =
      newVal === 'en' ? imagesRequire('./register-input-step-flow-2__en.png') : imagesRequire('./register-input-step-flow-2.png');
  },
  {
    immediate: true,
  }
);

/**
 * 選択されたフィールドを更新する
 * @param header - フィールド
 * @param updateValue - 更新する値
 */
const updateSelectedField = (header: LinkingBusinessHeader, updateValue: string) => {
  const beforeSelectedValue = state.value.linkingBusiness.linkedBusinessHeaders.find(
    (linkedHeader) => linkedHeader.key === header.key
  )?.value;

  // 選択肢から選択された値を削除
  state.value.uploadBusiness.businessHeaderCandidate = state.value.uploadBusiness.businessHeaderCandidate.map((candidate) => {
    if (candidate.value === updateValue) {
      return {
        ...candidate,
        alreadySelected: true,
      };
    }
    return candidate;
  });

  // 既に選択された値がある場合&選択された値とは違っていた場合、選択肢に復元する
  if (beforeSelectedValue && beforeSelectedValue !== updateValue) {
    state.value.uploadBusiness.businessHeaderCandidate = state.value.uploadBusiness.businessHeaderCandidate.map((candidate) => {
      if (candidate.value === beforeSelectedValue) {
        return {
          ...candidate,
          alreadySelected: false,
        };
      }
      return candidate;
    });
  }

  // 選択された値を更新
  state.value.linkingBusiness.linkedBusinessHeaders = state.value.linkingBusiness.linkedBusinessHeaders.map((linkedHeader) => {
    if (linkedHeader.key === header.key) {
      return {
        ...linkedHeader,
        value: updateValue !== UNSELECTED_HEADER_VALUE ? updateValue : undefined,
      };
    }
    return linkedHeader;
  });
};

/**
 * 戻るボタン
 */
const onClickBackButton = () => {
  emits('on-click-back');
};

/**
 * 次へボタン
 */
const onClickNextButton = () => {
  emits('on-click-next');
};

/**
 * 前回利用した値を使用ボタン
 */
const onClickUsePreviousValueButton = () => {
  emits('on-click-use-previous-value');
};

const selectedFieldSuggestions = computed(() => {
  return state.value.uploadBusiness.businessHeaderCandidate.map((candidate) => candidate.value);
});

/**
 * getter
 * @param header - ヘッダー
 */
const unusedLabel = (header: LinkingBusinessHeader) => {
  if (header.key === 'package' && header.unused) {
    return header.unused ? t('取引紐付け：文言不使用（数値）') : '';
  } else if (header.unused) {
    return header.unused ? t('取引紐付け：文言不使用') : '';
  } else {
    return '';
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(t)('取引紐付け：タイトル')), 1),
    _createElementVNode("img", {
      src: localedRegisterInputStepFlowImage.value,
      class: "linking-business__progress"
    }, null, 8, _hoisted_3),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("span", null, _toDisplayString(_unref(t)('取引紐付け：本文')), 1),
        (_unref(state).linkingBusiness.previousExcelInfo)
          ? (_openBlock(), _createBlock(TextButton, {
              key: 0,
              "button-style": 'btn-primary',
              size: 'btn-md',
              "on-click": onClickUsePreviousValueButton,
              disabled: false,
              class: "bulk-action-button-container__export-button"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('取引紐付け：前回利用ボタン')), 1)
              ], undefined, true),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("span", _hoisted_6, _toDisplayString(_unref(t)('取引紐付け：注釈')), 1)
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _withDirectives(_createElementVNode("input", {
          id: "radio-button-container__button--default-input",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(state).linkingBusiness.useLinkingType) = $event)),
          class: "radio-button-container__button",
          type: "radio",
          value: "Default"
        }, null, 512), [
          [_vModelRadio, _unref(state).linkingBusiness.useLinkingType]
        ]),
        _createElementVNode("label", _hoisted_9, _toDisplayString(_unref(t)('取引紐付け：ラジオボタン：デフォルト書式')), 1)
      ]),
      _createElementVNode("div", _hoisted_10, [
        _withDirectives(_createElementVNode("input", {
          id: "radio-button-container__button--original-input",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(state).linkingBusiness.useLinkingType) = $event)),
          class: "radio-button-container__button",
          type: "radio",
          value: "Original"
        }, null, 512), [
          [_vModelRadio, _unref(state).linkingBusiness.useLinkingType]
        ]),
        _createElementVNode("label", _hoisted_11, _toDisplayString(_unref(t)('取引紐付け：ラジオボタン：オリジナル書式')), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_12, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(state).linkingBusiness.linkedBusinessHeaders, (header) => {
        return (_openBlock(), _createElementBlock("div", {
          key: `linking-business-header-${header.key}`,
          class: "linking-container__at"
        }, [
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("span", _hoisted_15, _toDisplayString(_unref(t)(header.displayName) + (header.required ? '*' : '')), 1),
              (header.unused != null)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": ($event: any) => ((header.unused) = $event),
                      type: "checkbox",
                      class: "label-container__checkbox"
                    }, null, 8, _hoisted_16), [
                      [_vModelCheckbox, header.unused]
                    ]),
                    _createElementVNode("span", _hoisted_17, _toDisplayString(_unref(t)('取引紐付け：チェックボックス：不使用')), 1)
                  ], 64))
                : _createCommentVNode("", true)
            ]),
            (!header.unused)
              ? (_openBlock(), _createBlock(SelectableField, {
                  key: 0,
                  value: header.value,
                  "selected-id": selectedFieldId.value,
                  hint: _unref(t)('取引紐付け：サジェストヒント'),
                  suggestions: selectedFieldSuggestions.value,
                  onUpdateValue: ($event: any) => (updateSelectedField(header, $event)),
                  onUpdateSelectedId: _cache[2] || (_cache[2] = (id) => (selectedFieldId.value = id))
                }, null, 8, ["value", "selected-id", "hint", "suggestions", "onUpdateValue"]))
              : (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(unusedLabel(header)), 1))
          ]),
          _createElementVNode("span", _hoisted_19, _toDisplayString(header.validateError == 'NotSelected' ? _unref(t)('取引紐付け：アラート文言：必須項目') : '　'), 1)
        ]))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_20, [
      _createVNode(TextButton, {
        "button-style": 'btn-secondary',
        size: 'btn-md',
        "on-click": onClickBackButton,
        disabled: false,
        class: "bulk-action-button-container__export-button"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)('初期設定：戻るボタン')), 1)
        ], undefined, true),
        _: 1
      }),
      _createVNode(TextButton, {
        "button-style": 'btn-primary',
        size: 'btn-md',
        "on-click": onClickNextButton,
        disabled: false,
        class: "bulk-action-button-container__export-button"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)('初期設定：登録ボタン')), 1)
        ], undefined, true),
        _: 1
      })
    ])
  ]))
}
}

})